<template>
  <v-dialog v-model="isOpen" max-width="600px" scrollable>
    <v-card>
      <v-card-title class="justify-center" cols="12">
        <h2 v-if="isNew">
          Создание пользователя
        </h2>
        <h2 v-else>
          Редактирование пользователя
        </h2>
      </v-card-title>
      <v-card-text style="height: 85%;">
        <v-col
            cols="12"
        >
          <ValidationObserver ref="validationObserver" v-slot="{ handleSubmit }">
              <v-col
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="имя"
                    rules="required|max:120"
                >
                  <v-text-field
                      v-model="user.firstname"
                      :error-messages="errors"
                      label="Имя"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="фамилия"
                    rules="required|max:120"
                >
                  <v-text-field
                      v-model="user.lastname"
                      :error-messages="errors"
                      label="Фамилия"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            <v-col
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="отчество"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="user.middlename"
                    :error-messages="errors"
                    label="Отчество"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                  data-vv-validate-on="change"
              >
                <v-text-field
                    v-model="user.email"
                    :error-messages="errors"
                    label="E-mail"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="специальность"
                  rules="required"
              >
                <v-select
                    v-model="user.specialization"
                    :error-messages="errors"
                    :items="specializations"
                    label="Специальность"
                />
              </ValidationProvider>
            </v-col>
            <v-col
                v-if="isNew"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="пароль"
                  rules="required"
              >
                <v-text-field
                    v-model="user.password"
                    :error-messages="errors"
                    label="Пароль"
                />
              </ValidationProvider>
              <v-col
                  cols="12"
              >
                <v-checkbox
                    v-model="makeAdmin"
                    label="Администратор"
                />
              </v-col>
            </v-col>
            <v-col
                v-if="!isNew && isAdmin"
                cols="12"
            >
                <v-checkbox
                    v-model="isFired"
                    label="Уволен"
                />
              </v-col>
            <v-col class="alert">
              <v-alert
                  dense
                  icon="mdi-alert"
                  outlined
                  type="error"
                  :value="alert"
              >
                {{ errorText }}
              </v-alert>
            </v-col>
            <v-row justify="end">
              <v-spacer />
              <v-btn
                  class="mr-2"
                  color="blue darken-1"
                  text
                  @click="close"
                  :disabled="disabled"
              >
                Закрыть
              </v-btn>
              <v-btn
                  color="primary"
                  @click.prevent="handleSubmit(save)"
                  :disabled="disabled"
              >
                Сохранить
              </v-btn>
            </v-row>
          </ValidationObserver>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import roles from '../enum/role'
import specializations from '../enum/specializations'
import {mapGetters} from "vuex";

export default {
  name: 'UserEditor',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: Boolean,
    user: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data () {
    return {
      roles: roles,
      specializations: specializations,
      alert: false,
      errorText: '',
      disabled: false,
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.value
      },
      set (value) {
        this.$refs.validationObserver.reset();
        this.$emit('input', value)
      },
    },
    makeAdmin: {
      get () {
        return this.user.role === 'ADMIN'
      },
      set (value) {
        this.user.role = value ? 'ADMIN' : 'USER'
      },
    },
    isNew() {
      return !this.user.id;
    },
    isFired: {
      get () {
        return !this.user.active
      },
      set (value) {
        this.user.active = !value
      },
    },
    ...mapGetters({
      isAdmin: 'security/isAdmin',
    })
  },
  methods: {
    close () {
      this.isOpen = false
      this.$emit('on-close')
    },
    async save() {
      this.disabled = true
      if (!this.user.role) {
        this.user.role = 'USER';
      }

      try {
        if (this.isNew) {
          await this.$store.dispatch('users/create', this.user)
        } else {
          await this.$store.dispatch('users/update', this.user)
        }
        this.$toasted.success('Успешно сохранено')
        this.disabled = false
        this.isOpen = false
        this.errorText = ''
        this.alert = false
        this.$emit('on-save', this.item)
      } catch (err) {
        this.$toasted.error('Что то пошло не так')

        if (err.response.data.code === '23505') {
          this.alert = true
          this.errorText = 'Такой e-mail уже существует'
        }
        this.disabled = false
      }
    }
  }
}
</script>

<style scoped>

</style>
